<div class="card-header bg-white">
    <ng-container *ngIf="accessService.authorized(project, 'EDIT_IDEA')">
        <ng-template #authTemplate><div [innerHtml]="accessService.authReason(project, 'EDIT_IDEA')"></div></ng-template>
        <button type="button" class="btn btn-primary" placement="right" containerClass="auth-tooltip"
                *ngIf="viewMode === ViewMode.VIEW"
                (click)="setMode(ViewMode.EDIT)"
                [tooltip]="authTemplate"
                [delay]="500">Bearbeiten
        </button>
    </ng-container>

    <ng-container *ngIf="viewMode === ViewMode.EDIT">
        <button type="button" class="btn btn-success" [disabled]="form.invalid" (click)="update()">Speichern</button>
        <button type="button" class="btn btn-secondary ms-2" (click)="cancelEdit()">Abbrechen</button>
    </ng-container>

    <ng-container *ngIf="viewMode === ViewMode.INSERT">
        <button type="button" class="btn btn-success" [disabled]="form.invalid" (click)="save()">Speichern</button>
        <button type="button" class="btn btn-secondary ms-2" (click)="cancelCreate()">Abbrechen</button>
    </ng-container>
</div>
<div class="card-body">
    <form [formGroup]="form">

        <div class="row" *ngIf="projectService.hasStatus(project, ProjectStatus.LINE)">
            <div class="col">
                <div class="mb-2 p-2 bg-warning">
                    <label>An Linie übergeben am</label>
                    <div>{{ project?.date_line | date: 'dd.MM.yyyy' }}</div>
                </div>
            </div>
            <div class="col">
                <div class="mb-2">
                    <label>Verantwortliche Person</label>
                    <ng-container *ngIf="viewMode !== ViewMode.VIEW">
                        <input type="text" class="form-control" formControlName="quickwin_responsible" [maxlength]="50">
                        <div class="mb-1 small">{{ form.value.quickwin_responsible ? form.value.quickwin_responsible.length : 0 }}/50</div>
                    </ng-container>
                    <p *ngIf="viewMode === ViewMode.VIEW">
                        {{ form.value.quickwin_responsible }}
                        <span class="text-danger" *ngIf="!form.value.quickwin_responsible">Nicht eingetragen</span>
                    </p>
                </div>
            </div>
            <div class="col">
                <div class="mb-2">
                    <label>Kommentar</label>
                    <ng-container *ngIf="viewMode !== ViewMode.VIEW">
                        <textarea class="form-control" formControlName="quickwin_comment" rows="4" [maxlength]="255"></textarea>
                        <div class="mb-1 small">{{ form.value.quickwin_comment ? form.value.quickwin_comment.length : 0 }}/255</div>
                    </ng-container>
                    <p *ngIf="viewMode === ViewMode.VIEW">
                        {{ form.value.quickwin_comment }}
                        <span class="text-muted" *ngIf="!form.value.quickwin_comment">Nicht eingetragen</span>
                    </p>
                </div>
            </div>
        </div>

        <div class="row" *ngIf="PID() !== '0'">
            <div class="col">
                <div class="mb-2">
                    <label>Eingereicht von</label>
                    <p>{{ project?.creator }}</p>
                </div>
            </div>
            <div class="col">
                <div class="mb-2">
                    <label>Eingereicht am</label>
                    <p>{{ project?.date_created | date: 'dd.MM.yyyy' }}</p>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col">
                <div class="mb-2">
                    <label>Ideengeber</label>
                    <ng-container *ngIf="viewMode !== ViewMode.VIEW">
                        <input type="text" class="form-control" formControlName="ideator" [maxlength]="100">
                        <div class="mb-1 small">{{ form.value.ideator ? form.value.ideator.length : 0 }}/100</div>
                    </ng-container>
                    <p *ngIf="viewMode === ViewMode.VIEW">
                        {{ form.value.ideator }}
                        <span class="text-muted" *ngIf="!form.value.ideator">Nicht eingetragen</span>
                    </p>
                </div>
            </div>
            <div class="col">
                <div class="mb-2">
                    <label>Projektnummer</label>
                    <p>{{ project?.number }}</p>
                </div>
            </div>
        </div>

        <div class="mb-2" *ngIf="accessService.authorized(project, 'PROJECT_MIGRATE') && viewMode === ViewMode.INSERT && PID() === '0'">
            <label>Status</label>
            <select class="form-control" formControlName="status">
                <option *ngFor="let status of projectStatusList" [value]="status">
                    {{ status | projectStatus }}
                </option>
            </select>
        </div>

        <div class="row">
            <div class="col-6">
                <div class="mb-2">
                    <label>Länder</label>
                    <select class="form-control" formControlName="countries" *ngIf="viewMode !== ViewMode.VIEW" multiple>
                        <option value="" disabled selected style="display: none;">Länder in dem das Projekt durchgeführt wird</option>
                        <option *ngFor="let country of countries" [ngValue]="country">
                            {{ country.name }}
                        </option>
                    </select>
                    <p *ngIf="viewMode === ViewMode.VIEW">
                        {{ form.value.countryNames }}
                        <span class="text-muted" *ngIf="!form.value.countryNames">Nicht eingetragen</span>
                    </p>
                </div>
            </div>
            <div class="col-6" *ngIf="displayLocation()">
                <div class="mb-2">
                    <label>Standort</label>
                    <select class="form-control" formControlName="id_location" *ngIf="viewMode !== ViewMode.VIEW">
                        <option value="">Keine Auswahl</option>
                        <option *ngFor="let location of locations" [ngValue]="location.id">
                            {{ location.name }}
                        </option>
                    </select>
                    <p *ngIf="viewMode === ViewMode.VIEW">
                        {{ form.value.location }}
                        <span class="text-muted" *ngIf="!form.value.location">Nicht eingetragen</span>
                    </p>
                </div>
            </div>
        </div>

        <div class="mb-2">
            <label>Titel der Idee</label>
            <ng-container *ngIf="viewMode !== ViewMode.VIEW">
                <input type="text" class="form-control" formControlName="title" [maxlength]="80">
                <div class="mb-1 small">{{ form.value.title ? form.value.title.length : 0 }}/80</div>
            </ng-container>
            <p *ngIf="viewMode === ViewMode.VIEW">{{ form.value.title }}</p>
        </div>

        <div class="row">
            <div class="col">
                <div class="mb-2">
                    <label>Ausgangslage</label>
                    <ng-container *ngIf="viewMode !== ViewMode.VIEW">
                        <textarea class="form-control" formControlName="situation" rows="4" [maxlength]="1000"
                                  placeholder="Beschreiben Sie kurz die Ausgangslage und was den Anlass/Mehrwert für die Umsetzung dieser Projektidee darstellt">
                        </textarea>
                        <div class="mb-1 small">{{ form.value.situation ? form.value.situation.length : 0 }}/1000</div>
                    </ng-container>
                    <p *ngIf="viewMode === ViewMode.VIEW">{{ form.value.situation }}</p>
                </div>
            </div>
            <div class="col">
                <div class="mb-2">
                    <label>Nutzenbeschreibung</label>
                    <ng-container *ngIf="viewMode !== ViewMode.VIEW">
                        <textarea class="form-control" formControlName="benefit" rows="4" [maxlength]="1000"
                                  placeholder="Beschreiben Sie kurz welche Verbesserungen (der Ausgangslage) Sie sich nach einer erfolgreichen Projektumsetzung erwarten">
                        </textarea>
                        <div class="mb-1 small">{{ form.value.benefit ? form.value.benefit.length : 0 }}/1000</div>
                    </ng-container>
                    <p *ngIf="viewMode === ViewMode.VIEW">{{ form.value.benefit }}</p>
                </div>
            </div>
        </div>

        <h4>Dokumente</h4>

        <div class="table-responsive">
            <table class="table table-sm table-hover table-files">
                <thead>
                <tr>
                    <th style="width: 85px"></th>
                    <th style="width: 120px">Vorschau</th>
                    <th>Typ</th>
                    <th>Name</th>
                    <th></th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let file of files">
                    <td>
                        <button type="button" class="btn btn-danger btn-sm" *ngIf="viewMode !== ViewMode.VIEW" (click)="deleteOrRemoveFile(file)">
                            <i class="fa-solid fa-trash"></i>
                        </button>
                        <button type="button" class="btn btn-success btn-sm ms-2" (click)="getFileData(file)">
                            <i class="fa-solid fa-download"></i>
                        </button>
                    </td>
                    <td>
                        <ng-container *ngIf="file.type.startsWith('image')">
                            <img class="img-fluid" *ngIf="file.thumbnail" [src]="'data:' + file.type + ';base64,' + file.thumbnail">
                            <img class="img-fluid" *ngIf="file.data" [src]="file.data">
                        </ng-container>
                        <ng-container *ngIf="!file.type.startsWith('image')">
                            Nicht verfügbar
                        </ng-container>
                    </td>
                    <td>
                        {{ file.type | filetype }}
                    </td>
                    <td>
                        {{ file.name }}
                    </td>
                </tr>
                </tbody>
            </table>

            <p class="text-muted" *ngIf="files.length === 0">Keine Anhänge vorhanden</p>
        </div>

        <div [hidden]="viewMode === ViewMode.VIEW">
            <button type="button" class="btn btn-secondary btn-sm" (click)="triggerFileInput()">Foto oder Datei hochladen</button>
            <input type="file" #fileInput class="d-none" multiple (change)="handleInputChange($event)">
        </div>
    </form>
</div>
